import React, { useState, useRef, useCallback } from "react";
import Main from "./Main";
import "primeicons/primeicons.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { ColorPicker } from "primereact/colorpicker";
import { Toast } from "primereact/toast";

import QRCode from "react-qr-code";
//
const QrCode = () => {
  const toast = useRef(null);

  const [link, setLink] = useState("");
  const [value, setValue] = useState("");
  const [size, setSize] = useState(200);
  const [color, setColor] = useState();

  const submit = () => {
    if (link) {
      setValue(link);
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Insert a link",
      });
    }
  };

  const download = () => {
    // console.log(document.getElementById("QrCodeSVG"));

    const svgElement = document.getElementById("QrCodeSVG");
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);

    // Create a canvas and draw the SVG onto it
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Set the canvas size to the SVG size
    canvas.width = svgElement.width.baseVal.value;
    canvas.height = svgElement.height.baseVal.value;

    // Create an image element
    const img = new Image();
    const svgBlob = new Blob([svgString], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      // Draw the image onto the canvas
      ctx.drawImage(img, 0, 0);

      // Create a PNG from the canvas
      const pngUrl = canvas.toDataURL("image/png");

      // Create a temporary link to trigger the download
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "QrCode.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    };

    // Set the source of the image to the URL created from the SVG blob
    img.src = url;
  };

  return (
    <>
      <Main />
      <Toast ref={toast} position="top-left" />
      <Container fluid>
        <Row className="m-1" style={{ border: "solid 3spx silver" }}>
          <Col sm={3}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                <b> Link To convert to Qr</b>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Link to Convert"
                onChange={(e) => (setLink(e.target.value), setValue(""))}
              />
              <Form.Text className="text-muted"></Form.Text>
            </Form.Group>

            <Form.Group className="mb-3" controlId="">
              <ColorPicker
                value={color}
                onChange={(e) => setColor(e.value)}
                inline
              />
            </Form.Group>
          </Col>

          <Col>
            <Form.Group className="mb-3" controlId="">
              <Form.Label>Qr Size</Form.Label>
              <Form.Range
                min="100"
                max="600"
                defaultValue={200}
                onChange={(e) => setSize(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="">
              <Button
                variant="primary"
                type="submit"
                className="btn-lg"
                onClick={submit}
              >
                Click to generate
              </Button>
            </Form.Group>
          </Col>

          <Col>
            <Form.Group className="mb-3 " controlId="">
              {value && (
                <Form.Label>
                  <b style={{ color: "red" }}>Click on Qr Code to download</b>
                </Form.Label>
              )}
              <br></br>
              {value && (
                <QRCode
                  title="GeeksForGeeks"
                  value={value}
                  bgColor={"#FFFFFF"}
                  fgColor={`#${color}`}
                  size={size === "" ? 0 : size}
                  className="m-2"
                  id="QrCodeSVG"
                  onClick={download}
                />
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row></Row>
      </Container>
    </>
  );
};

export default QrCode;
